import { render, staticRenderFns } from "./TradeCurve.vue?vue&type=template&id=7045a0f8"
import script from "./TradeCurve.vue?vue&type=script&lang=js"
export * from "./TradeCurve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports